import PropTypes from 'prop-types';

import OECoreHideLayer from '../oe-core-hide-layer';
import {OEHideFlags} from '../../../react-oe/oe-types';

export const OEWelcomeViewType = {
    none:                                   'none',
    cambridgeCell:                          'cambridgeCell',
    disclaimer:                             'disclaimer',
    register:                               'register',
    zeissUV:                                'zeissUV'
};

//
export const OEWelcomeViewProps = {

    configDecl: {
        type:                               PropTypes.string,
        logo:                               PropTypes.string,
        showAtStartUp:                      PropTypes.bool,
        welcomeViewShowedAtStartFlag:       PropTypes.bool,
        src:                                PropTypes.string,
        srcId:                              PropTypes.string,
        privacySrc:                         PropTypes.string,
        privacySrcId:                       PropTypes.string,
        coreHideFlags:                      OECoreHideLayer.propTypes.hideFlags,
        showStartView:                      PropTypes.bool,
        noAcceptTermsCheckbox:              PropTypes.bool
    }
};

OEWelcomeViewProps.config = PropTypes.shape(OEWelcomeViewProps.configDecl);

OEWelcomeViewProps.propTypes = {
    moduleId:                               PropTypes.string,
    config:                                 OEWelcomeViewProps.config
};

//
export const OEWelcomeViewConfigFactory = {

    buildStdConfig()    {
        return {
            type:                           OEWelcomeViewType.none,
            logo:                           null,
            showAtStartUp:                  true,
            welcomeViewShowedAtStartFlag:   true,
            coreHideFlags:                  OEHideFlags.none,
            showStartView:                  false
        };
    }
};

//
OEWelcomeViewProps.defaultProps = {
    moduleId:                               '',
    config:                                 OEWelcomeViewConfigFactory.buildStdConfig()
};